import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const regionalCooBaseUrl = '/api/regional-coordinators';
export const regionalCooApi = createApi({
  reducerPath: 'regionalCooApi',
  baseQuery: customBaseQuery,
  tagTypes: ['RegionalCoordinator'],
  endpoints: (builder) => ({
    getRegionalCoordinators: builder.query<RegionalCoordinatorsData[], RegionalCoordinatorsParams>({
      query: (params) => ({
        url: regionalCooBaseUrl,
        params,
      }),
      providesTags: ['RegionalCoordinator'],
    }),
    updateRegionalCoordinator: builder.mutation<
      RegionalCoordinatorsData,
      UpdateRegionalCoordinatorPayload
    >({
      query: (body) => ({
        url: regionalCooBaseUrl,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['RegionalCoordinator'],
    }),
  }),
});

export const {
  useGetRegionalCoordinatorsQuery,
  useLazyGetRegionalCoordinatorsQuery,
  useUpdateRegionalCoordinatorMutation,
} = regionalCooApi;
